import { defineMessages } from 'react-intl-next';

export const i18n: {
    assetsType: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    assetsFilterAssetsTypePlaceholder: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    assetsFilterLabelSelected: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    assetsFilterLabelUnselected: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    assetsIconLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    };
} = defineMessages({
	assetsType: {
		id: 'quick-find.filters.names.assets-type',
		defaultMessage: 'Object type',
		description: 'Label for filtering by assets type',
	},
	assetsFilterAssetsTypePlaceholder: {
		id: 'quick-find.assets.filter.assets-type.placeholder',
		defaultMessage: 'Find object types',
		description: 'Placeholder for assets type filter search input',
	},
	assetsFilterLabelSelected: {
		id: 'quick-find.assets.filter.assets-type.label.selected',
		defaultMessage: 'Selected',
		description: 'Label for selected object types',
	},
	assetsFilterLabelUnselected: {
		id: 'quick-find.assets.filter.assets-type.label.unselected',
		defaultMessage: 'Suggested',
		description: 'Label for suggested object types',
	},
	assetsIconLabel: {
		id: 'quick-find.assets.filter.assets-type.icon.label',
		defaultMessage: 'Object type filter',
		description:
			'An icon that is displayed when there are no products selected to signify that the filter is associated with Assets',
	},
});
